export default __webpack_public_path__ + "static/media/error.181c5a64.gif";